module.exports = __webpack_public_path__ + "static/trailer-62e34d63634d11ba9e7c1be42bbc8f24.mp4";